import React, { useEffect } from 'react';
import { PropTypes, string, bool, func } from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { PaypalMessage } from './PaypalMessage';

const PaypalPriceMessaging = (props) => {
  const {
    payInFour,
    orderTotal,
    fromPage,
    namespace,
    fontSize
  } = props;

  const isPaypalEnabled = useConfigService('PAYPAL_ENABLE');
  const paypalClientId = useConfigService('PAYPAL_CLIENT_ID');

  if (!isPaypalEnabled) {
    return false;
  }

  return (
    <div data-component="PaypalCheckoutButton">
      <ErrorBoundary name="paypal-checkout-button-price">
        <PayPalScriptProvider options={{
          clientId: paypalClientId,
          enableFunding: 'paylater',
          disableFunding: 'card',
          components: 'buttons,funding-eligibility,messages',
          intent: 'order',
          commit: 'false',
          dataNamespace: namespace
        }}
        >
          {(payInFour) && (
            <div className="sui-col-span-2" data-testid="paypal-pay-in-four-message">
              {PaypalMessage(orderTotal, fromPage, fontSize)}
            </div>
          )}
        </PayPalScriptProvider>
      </ErrorBoundary>
    </div>
  );
};

PaypalPriceMessaging.propTypes = {
  payInFour: bool,
  orderTotal: string.isRequired,
  fromPage: string.isRequired,
  namespace: string,
  fontSize: string
};

PaypalPriceMessaging.defaultProps = {
  payInFour: false,
  namespace: 'paypalSdk',
  fontSize: '12'
};

PaypalPriceMessaging.displayName = 'PaypalPriceMessaging';

export { PaypalPriceMessaging };